import theme from '../../../theme';

const styles = {
  outerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: '100%',
    paddingBottom: 1.5,
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.divider,
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.primary.main
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      opacity: 0
    },
    '&:hover::-webkit-scrollbar': {
      opacity: 1
    }
  },
  innerContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    pb: 1.5
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1.5,
    px: 2.5,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  clicksText: {
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
    fontSize: '0.75rem'
  },
  urlContainer: {
    flex: 1,
    mr: 2.5,
    minWidth: 0
  },
  url: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    fontSize: '0.75rem',
    lineHeight: 1.4
  }
};

export default styles;
